











































































































































































































































import { computed } from "@nuxtjs/composition-api";
import { useUiState } from "~/composables/useUiState";
import {
  defineComponent,
  ref,
  watch,
  onMounted,
  useContext,
  useRoute
} from "@nuxtjs/composition-api";
import type { PropType } from "@nuxtjs/composition-api";
import { required, email } from "vee-validate/dist/rules";
import { extend } from "vee-validate";
import { LoginFormFields, FormName } from "./types";
import { useConfigStore } from "~/stores/extensionApi";
import { useUiNotification } from "~/composables";
import { useOtpLogin } from "~/modules/customer/composables/useOtpLogin";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import GoCaptcha from "./GoCaptcha.vue";
import SkeletonLoader from "~/components/SkeletonLoader/index.vue";
import { useCart } from '~/modules/checkout/composables/useCart';
import { useClevertapStore } from "~/stores/clevertap";

extend("email", {
  ...email,
  message: "Email không hợp lệ",
});

extend("required", {
  ...required,
  message: "Trường này là bắt buộc",
});

export default defineComponent({
  components: {
    GoCaptcha,
    SkeletonLoader,
  },
  props: {
    form: {
      type: Object as PropType<LoginFormFields>,
      required: true,
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    showRecaptcha: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const hidePopupCaptcha = ref(true);
    const mobileNumber = ref("");
    const showUpdateProfile = ref(false);
    const isOtpSent = ref(false);
    const isChooseOptionOtp = ref(false);
    const visitorId = ref("");
    const otpLoginAuth = ref(0);
    const isOtpResultError = ref(false);
    const otp = ref("");
    const isOtpComplete = ref(false);
    const isOtpConfirm = ref(false);
    const minutes = ref("02");
    const seconds = ref("00");
    const otpInput = ref(null);

    let interval = null;

    const { otpLogin, otpConfirm, loginOtpZalo, loading, result, error } = useOtpLogin();

    const { isLoginModalOpen, toggleLoginModal } = useUiState();

    const { send: sendNotification } = useUiNotification();

    const storeConfig = useConfigStore();

    const loginImage = computed(() => storeConfig.getLoginImage);

    const isEnabledZalo = computed(() => storeConfig.getZaloEnabled);

    const otpConfig = computed(() => storeConfig.getOtpConfig);
    const { load: loadCart } = useCart();
    const clevertapStore = useClevertapStore();
    const route = useRoute();
    const { app } = useContext();

    // Function to determine login position based on route
    const getLoginPosition = () => {
      const path = route.value.path;
      const query = route.value.query;
      
      // Check various paths to determine login position
      if (path.includes('/checkout')) return 'checkout';
      if (path.includes('/account')) return 'account';
      if (path.includes('/c-live')) return 'c-live';
      if (path.includes('/wishlist')) return 'wish list';
      if (path.includes('/cart')) return 'cart';
      if (path.includes('/tra-cuu-don-hang')) return 'tra-cuu-don-hang';
      
      // Check if there's a voucher-related query parameter
      if (path.includes('/voucher') || query.voucher || query.coupon) return 'voucher code';
      
      // Check specific account sections
      if (path.includes('/account/orders')) return 'order';
      if (path.includes('/account/member-card')) return 'member card';
      if (path.includes('/account/address')) return 'address';
      
      // Default position if nothing specific is detected
      return 'account';
    };

    // Track successful login
    const trackLoginSuccess = (phoneNumber) => {
      if (!process.client) return;
      
      try {
        const win = window as any;
        if (!win.clevertap) return;
        
        // Prepare tracking data
        const trackingData = {
          phone_number: phoneNumber.replace(/^0/, ''), // Remove leading zero (if you want to match your example)
          position: getLoginPosition()
        };
        
        // Send the event to CleverTap
        clevertapStore.loginSuccessfulCleverTap({
          clevertap: win.clevertap,
          data: trackingData
        });
      } catch (error) {
        console.error('Error tracking login success:', error);
      }
    };
    
    // Track failed login
    const trackLoginFailed = (phoneNumber, errorMessage) => {
      if (!process.client) return;
      
      try {
        const win = window as any;
        if (!win.clevertap) return;
        
        // Prepare tracking data
        const trackingData = {
          phone_number: phoneNumber.replace(/^0/, ''), // Remove leading zero (if you want to match your example)
          position: getLoginPosition(),
          error_message: errorMessage
        };
        
        // Send the event to CleverTap
        clevertapStore.loginFailedCleverTap({
          clevertap: win.clevertap,
          data: trackingData
        });
      } catch (error) {
        console.error('Error tracking login failure:', error);
      }
    };

    const formCopy = ref<LoginFormFields>();
    watch(
      () => props.form,
      (newForm) => {
        formCopy.value = { ...newForm };
      },
      { immediate: true, deep: true }
    );
    const changeForm = (formToNavigateTo: FormName) => {
      emit("change-form", formToNavigateTo);
    };
    const closeModal = () => {
      if (isLoginModalOpen) {
        // Track login failure when closing modal without logging in
        if (mobileNumber.value) {
          trackLoginFailed(mobileNumber.value, "Không đăng nhập");
        }
        toggleLoginModal();
      }
    };

    const parseIntTime = (time) => {
      return parseInt(time);
    };

    const regexPhoneNumber = (phone) => {
      const regexPhoneNumber = /([0]+(3|5|7|8|9|1[2|6|8|9]))+([0-9]{8})\b/;
      return regexPhoneNumber.test(phone);
    };

    const handleOtpLoginSms = async (includeVisitorId = true) => {
      otpLoginAuth.value = 2;

      if(!otpConfig.value?.is_enabled_captcha) {
        includeVisitorId = false;
      }

      try {
        const payload = {
          mobileNumber: mobileNumber.value,
          ...(includeVisitorId && { visitorId: visitorId.value }),
        };
        await otpLogin(payload);

        if (result.value.otpLoginResult && !includeVisitorId && !error.value.otpLogin) {
          isChooseOptionOtp.value = false;
          isOtpSent.value = true;

          sendNotification({
            id: Symbol("otp_success"),
            message: "Gửi otp thành công!",
            type: "success",
            icon: "check",
            persist: false,
            title: "Gửi otp SMS",
          });
          countDownTimeMethods();
        } else if (
          error.value.otpLogin &&
          error.value.otpLogin.message === "visitor_id_not_valid"
        ) {
          hidePopupCaptcha.value = false;
          isChooseOptionOtp.value = false;
        } else if (result.value.otpLoginResult && includeVisitorId) {
          isChooseOptionOtp.value = false;
          isOtpSent.value = true;

          sendNotification({
            id: Symbol("otp_success"),
            message: "Gửi otp thành công!",
            type: "success",
            icon: "check",
            persist: false,
            title: "Gửi otp SMS",
          });
          countDownTimeMethods();
        } else {
          sendNotification({
            id: Symbol("otp_login_error"),
            message: error.value.otpLogin.message,
            type: "danger",
            icon: "cross",
            persist: false,
            title: "Tài khoản người dùng",
          });
          isChooseOptionOtp.value = false;
        }
      } catch (err) {
        sendNotification({
          id: Symbol("otp_login_error"),
          message: err.message,
          type: "danger",
          icon: "cross",
          persist: false,
          title: "Tài khoản người dùng",
        });
      }
    };

    const handleOtpLoginZalo = async (includeVisitorId = true) => {
      otpLoginAuth.value = 1;

      if(!otpConfig.value?.is_enabled_captcha) {
        includeVisitorId = false;
      }

      try {
        const payload = {
          mobileNumber: mobileNumber.value,
          ...(includeVisitorId && { visitorId: visitorId.value }),
        };
        await loginOtpZalo(payload);

        if (result.value.otpLoginResult && !includeVisitorId && !error.value.otpLogin) {
          isChooseOptionOtp.value = false;
          isOtpSent.value = true;

          sendNotification({
            id: Symbol("otp_success"),
            message: "Gửi otp thành công!",
            type: "success",
            icon: "check",
            persist: false,
            title: "Gửi otp Zalo",
          });
          countDownTimeMethods();
        } else if (
          error.value.otpLogin &&
          error.value.otpLogin.message === "visitor_id_not_valid"
        ) {
          hidePopupCaptcha.value = false;
          isChooseOptionOtp.value = false;
        } else if (result.value.otpLoginResult && includeVisitorId) {
          isChooseOptionOtp.value = false;
          isOtpSent.value = true;

          sendNotification({
            id: Symbol("otp_success"),
            message: "Gửi otp thành công!",
            type: "success",
            icon: "check",
            persist: false,
            title: "Gửi otp Zalo",
          });
          countDownTimeMethods();
        } else {
          sendNotification({
            id: Symbol("otp_login_error"),
            message: error.value.otpLogin.message,
            type: "danger",
            icon: "cross",
            persist: false,
            title: "Tài khoản người dùng",
          });
          isChooseOptionOtp.value = false;
        }
      } catch (err) {
        sendNotification({
          id: Symbol("otp_login_error"),
          message: err.message,
          type: "danger",
          icon: "cross",
          persist: false,
          title: "Tài khoản người dùng",
        });
      }
    };

    const clearOtpInput = () => {
      if (otpInput.value) {
        otpInput.value.clearInput();
      }
    };

    const resendOtp = async () => {
      restartCountDown();
      isOtpComplete.value = false;
      isOtpConfirm.value = false;
      isOtpResultError.value = false;
      clearOtpInput();

      if (otpLoginAuth.value === 1) {
        await handleOtpLoginZalo(false);
      } else if (otpLoginAuth.value === 2) {
        await handleOtpLoginSms(false); // Call without visitorId
      }
    };

    const handleOnChangeOtp = (value) => {
      if (value?.length < 4) {
        isOtpResultError.value = false;
      }
    };

    const onOtpComplete = (value) => {
      otp.value = value;
      isOtpComplete.value = true;
      if (parseIntTime(seconds.value) > 0) {
        otpConfirmSubmit();
      }
    };

    const otpConfirmSubmit = async () => {
      if (!isOtpComplete.value) {
        const errorMessage = "Vui lòng nhập mã OTP!";
        sendNotification({
          id: Symbol("otp_incomplete"),
          message: errorMessage,
          type: "danger",
          icon: "cross",
          persist: false,
          title: "Verify otp",
        });
        
        // Track login failure - OTP not entered
        trackLoginFailed(mobileNumber.value, errorMessage);
        return;
      }
      sendNotification({
        id: Symbol("otp_checking"),
        message: "Đang kiểm tra ...",
        type: "info",
        icon: "info",
        persist: false,
        title: "Verify otp",
      });

      try {
        await otpConfirm({
          mobileNumber: mobileNumber.value,
          otp: otp.value,
        });
        if (result.value.otpConfirmResult.isOtpConfirm) {
          // Track successful login
          trackLoginSuccess(mobileNumber.value);
          
          resetData();

          sendNotification({
            id: Symbol("otp_success"),
            message: "Bạn đã đăng nhập thành công!",
            type: "success",
            icon: "check",
            persist: false,
            title: "Verify otp",
          });
          await Promise.all([loadCart()]);

        } else if (error.value.otpConfirm) {
          const errorMessage = "Mã OTP không chính xác";
          isOtpResultError.value = true;
          isOtpSent.value = true;
          
          // Track login failure - Invalid OTP
          trackLoginFailed(mobileNumber.value, errorMessage);
          
          sendNotification({
            id: Symbol("otp_confirm_error"),
            message: errorMessage,
            type: "danger",
            icon: "check",
            persist: false,
            title: "Verify otp",
          });
        }
      } catch (err) {
        // Track login failure - General error
        trackLoginFailed(mobileNumber.value, err.message || "Không đăng nhập");
        
        sendNotification({
          id: Symbol("otp_confirm_error"),
          message: err.message,
          type: "danger",
          icon: "cross",
          persist: false,
          title: "Verify otp",
        });
      }
    };

    const chooseOption = async () => {
      if (!regexPhoneNumber(mobileNumber.value)) {
        sendNotification({
          id: Symbol("invalid_mobile_number"),
          message: "Số điện thoại không hợp lệ",
          type: "danger",
          icon: "cross",
          persist: false,
          title: "Tài khoản người dùng",
        });
        return;
      }
      if (mobileNumber.value.length !== 10) {
        sendNotification({
          id: Symbol("invalid_mobile_number_length"),
          message: "Số điện thoại phải có 10 chữ số",
          type: "danger",
          icon: "cross",
          persist: false,
          title: "Tài khoản người dùng",
        });
        return;
      }
      if (mobileNumber.value === "") {
        sendNotification({
          id: Symbol("empty_mobile_number"),
          message: "Số điện thoại không được để trống",
          type: "danger",
          icon: "cross",
          persist: false,
          title: "Tài khoản người dùng",
        });
        return;
      }
      isChooseOptionOtp.value = true;
    };

    const countDownTimeMethods = () => {
      let times = parseInt(getTimeResendOtp());
      interval = setInterval(() => {
        times = times - 1;
        const { minutes: min, seconds: sec } = getTimeLeft(times);

        if (sec === 0 && min > 0) {
          minutes.value = (min - 1).toString().padStart(2, "0");
          seconds.value = "60";
        } else {
          minutes.value = min.toString().padStart(2, "0");
          seconds.value = sec.toString().padStart(2, "0");
        }

        if (parseInt(minutes.value) < 0) {
          minutes.value = "00";
        }
        if (parseInt(seconds.value) < 0) {
          seconds.value = "00";
        }
      }, 1000);
    };

    const restartCountDown = async () => {
      clearInterval(interval);
    };
    const resetData = async () => {
      isOtpResultError.value = false;
      hidePopupCaptcha.value = true;
      mobileNumber.value = "";
      otp.value = "";
      isOtpSent.value = false;
      isOtpConfirm.value = false;
      isOtpComplete.value = false;
      showUpdateProfile.value = false;
      closeModal();
      restartCountDown();
    };

    const getTimeResendOtp = () => {
      return otpConfig.value?.time_resend_otp;
    };

    const getTimeLeft = (times) => {
      const minutes = Math.floor(times / 60);
      const seconds = times % 60;
      return { minutes, seconds };
    };

    watch(mobileNumber, (newValue) => {
      newValue = newValue.trim();
      if (newValue.length > 10) {
        mobileNumber.value = newValue.substring(0, 10);
      } else {
        mobileNumber.value = newValue;
      }
    });

    onMounted(async () => {
      const fpPromise = FingerprintJS.load();
      const fp = await fpPromise;
      const result = await fp.get();
      visitorId.value = result.visitorId;
    });

    return {
      formCopy,
      changeForm,
      closeModal,
      loginImage,
      isEnabledZalo,
      otpConfig,
      mobileNumber,
      chooseOption,
      isChooseOptionOtp,
      isOtpSent,
      loading,
      result,
      error,
      handleOtpLoginSms,
      handleOtpLoginZalo,
      handleOnChangeOtp,
      onOtpComplete,
      otpConfirm,
      otpConfirmSubmit,
      otpLoginAuth,
      isOtpResultError,
      otp,
      isOtpComplete,
      isOtpConfirm,
      showUpdateProfile,
      minutes,
      seconds,
      countDownTimeMethods,
      restartCountDown,
      parseIntTime,
      resendOtp,
      hidePopupCaptcha,
      visitorId,
      resetData,
      regexPhoneNumber,
      otpInput,
      clearOtpInput,
      trackLoginSuccess,
      trackLoginFailed,
    };
  },
});
